






























































import { Component, Vue } from 'vue-property-decorator';
import { DashboardModule } from '@/store/Dashboard/DashboardModule';
import { AuthModule } from '@/store/Auth/AuthModule';

@Component({ name: 'BalancesWidget' })
export default class extends Vue {

    async beforeMount() {
        await DashboardModule.getSegregatedBalances();
    }

    get loading() {
        return DashboardModule.loadingBalances;
    }

    get balances() {
        return DashboardModule.balances;
    }

    get institutionConfig() {
        return AuthModule.me.institution.config;
    }

    get institutionAccountsLabel() {
        return AuthModule.me.institution.config.labels.institutionAccounts;
    }

}
